import { ERASE_BUFFER_GLOBAL, SET_GLOBAL_SUCCESS } from './constants';

let globalObj = {
    quizType: 'quiz',
    saveAction: false,
    actionBuff: []
};

/**
 *
 * @param state
 * @param elm
 * @returns {[]|*[]}
 */
const addElmToState = ( state, elm ) => {
    let actionBuff = [];

    if ( state.actionBuff.length > 0 ) {

        try {
            if ( typeof elm.actionBuff[ 0 ] === 'undefined' || typeof Object.keys( elm.actionBuff[ 0 ] ) === 'undefined' ) {
                throw new Error( 'Object.keys(elm.actionBuff[0])[0] is undefined' );
            }

            const key = Object.keys( elm.actionBuff[ 0 ] )[ 0 ];

            const ifThereIs = state.actionBuff.findIndex( ( elm ) => {
                return Object.keys( elm )[ 0 ] === key;
            } );

            if ( ifThereIs === -1 ) {
                // if the action doesn't have in an action buffer that we add it
                actionBuff = [ ...state.actionBuff, ...elm.actionBuff ];
            } else {
                let i = 0;
                // if the action has in an action buffer that we update link
                while ( i < state.actionBuff.length ) {
                    const key = Object.keys( elm.actionBuff[ 0 ] )[ 0 ];

                    if ( state.actionBuff[ i ].hasOwnProperty( key ) ) {
                        state.actionBuff[ i ] = elm.actionBuff[ 0 ];
                        actionBuff = [ ...state.actionBuff ];
                        break;
                    }

                    i++;
                }
            }
        } catch ( e ) {
            return [ ...state.actionBuff ];
        }

    } else {
        actionBuff = elm.hasOwnProperty( 'actionBuff' ) ? [ ...state.actionBuff, ...elm.actionBuff ] : [];
    }

    return actionBuff;
};
/**
 *
 * @param state
 * @param action
 * @returns {{actionBuff: [], saveAction: boolean, quizType: string}}
 */
const globalReducer = ( state = globalObj, action ) => {

    switch ( action.type ) {

        case SET_GLOBAL_SUCCESS: {

            let actionBuff = addElmToState( state, action.obj.obj );
            globalObj = { ...state, ...action.obj.obj, actionBuff: actionBuff };

            return globalObj;
        }

        case ERASE_BUFFER_GLOBAL: {

            globalObj = { ...state, saveAction: false, actionBuff: [] };

            return globalObj;
        }

        default:
            return state;
    }
};

export { globalReducer as global };